<template>
	<div class="page-form-cont detail-cont">
		<div class="detail-wrapper">
			<div class="module">
				<div class="module-title">
					<div class="module-title-text">保单基本信息</div>
				</div>
			</div>
			<div class="module-cont">
				<div class="info-grid">
					<div class="info-item">
						<span class="info-label">创建时间</span>
						<span class="info-value">{{ policyInfo.policyCreateTime }}</span>
					</div>
					<div class="info-item">
						<span class="info-label">客户姓名</span>
						<span class="info-value">{{ policyInfo.userName }}</span>
					</div>
					<div class="info-item">
						<span class="info-label">联系电话</span>
						<span class="info-value">{{ policyInfo.phoneNo }}</span>
					</div>
					<div class="info-item">
						<span class="info-label">证件类型</span>
						<span class="info-value">{{ policyInfo.idType }}</span>
					</div>
					<div class="info-item">
						<span class="info-label">证件号码</span>
						<span class="info-value">{{ policyInfo.idCardNo }}</span>
					</div>
					<div class="info-item">
						<span class="info-label">渠道名称</span>
						<span class="info-value">{{ policyInfo.channelCode }}</span>
					</div>
					<div class="info-item">
						<span class="info-label">产品名称</span>
						<span class="info-value">{{ policyInfo.productName }}</span>
					</div>
					<div class="info-item">
						<span class="info-label">保单生效时间</span>
						<span class="info-value">{{ policyInfo.policyStartTime }}</span>
					</div>
					<div class="info-item">
						<span class="info-label">保单终止时间</span>
						<span class="info-value">{{ policyInfo.policyEndTime }}</span>
					</div>
					<div class="info-item">
						<span class="info-label">手机IMEI号</span>
						<span class="info-value">{{ policyInfo.imei }}</span>
					</div>
				</div>
			</div>
			<template v-if="policyInfo.woRepairNo">
				<div class="module">
					<div class="module-title">
						<div class="module-title-text">工单详情</div>
					</div>
				</div>
				<div class="module-cont">
					<div class="info-grid">
						<div class="info-item">
							<span class="info-label">创建时间</span>
							<span class="info-value">{{ policyInfo.woCreateTime }}</span>
						</div>
						<div class="info-item">
							<span class="info-label">保单id</span>
							<span class="info-value">{{ policyInfo.policyId }}</span>
						</div>
						<div class="info-item">
							<span class="info-label">工单类型</span>
							<span class="info-value">{{ claimStatusList.find(item => item.value == policyInfo.woAcceptType)?.label || "" }}</span>
						</div>
						<!-- <div class="info-item">
							<span class="info-label">工单电话</span>
							<span class="info-value">{{ policyInfo.woCallPhone }}</span>
						</div> -->
						<!-- <div class="info-item">
							<span class="info-label">工单身份证</span>
							<span class="info-value">{{ policyInfo.woIdCardNo }}</span>
						</div> -->
						<div class="info-item">
							<span class="info-label">身份证姓名</span>
							<span class="info-value">{{ policyInfo.woIdName }}</span>
						</div>
						<div class="info-item">
							<span class="info-label">工单回寄地址</span>
							<span class="info-value">{{ policyInfo.woRebackAddr }}</span>
						</div>
						<div class="info-item">
							<span class="info-label">损坏情况</span>
							<span class="info-value">{{ policyInfo.woBrokenDesc }}</span>
						</div>
					</div>
				</div>

				<div class="module">
					<div class="module-title">
						<div class="module-title-text">工单流转详情</div>
					</div>
				</div>
				<div class="module-cont">
					<div v-for="(item, index) in policyInfo.circulationInfoDTOS || []" :key="index" class="flow-item">
						<div class="flow-info">
							<div class="flow-row status-row">
								<!-- <span class="flow-label">工单状态</span> -->
								<span class="flow-value status-text">{{ item.woRepairStatusDesc || "" }}</span>
							</div>
							<!-- 自取展示 -->
							<template v-if="item.woRepairStatus === 'rep_self_taken'">
								<div class="flow-row">
									<span class="flow-label">操作时间</span>
									<span class="flow-value">{{ item.woOperateTime }}</span>
								</div>
								<div class="flow-row">
									<span class="flow-label">取机姓名</span>
									<span class="flow-value">{{ item.takeUserName }}</span>
								</div>
								<!-- <div class="flow-row">
									<span class="flow-label">联系电话</span>
									<span class="flow-value">{{ item.takeUserPhone }}</span>
								</div> -->
								<div class="flow-row">
									<span class="flow-label">取机时间</span>
									<span class="flow-value">{{ item.takeTime }}</span>
								</div>
								<div class="flow-row">
									<span class="flow-label">备注</span>
									<span class="flow-value">{{ item.woRemarks }}</span>
								</div>
							</template>
							<!-- 报价展示 -->
							<template v-else-if="item.woRepairStatus === 'rep_confirm_quote' || item.woRepairStatus === 'rep_again_quote'">
								<div class="flow-row">
									<span class="flow-label">操作时间</span>
									<span class="flow-value">{{ item.woOperateTime }}</span>
								</div>
								<div class="flow-row">
									<span class="flow-label">操作人</span>
									<span class="flow-value">{{ item.woOperator }}</span>
								</div>
								<div class="quote-section">
									<div class="quote-label">报价信息</div>
									<div v-for="priceItem in item.quotaDTOList || []" :key="priceItem.quoteTimes" class="quote-box">
										<div class="quote-row">报价次数：{{ `第${priceItem.quoteTimes}次报价` }}</div>
										<div class="quote-row">损坏部位：{{ priceItem.damagePart }}</div>
										<div class="quote-row">配件价格：{{ priceItem.partQuote }}</div>
										<div class="quote-row">工时费：{{ priceItem.manHourQuote }}</div>
										<div class="quote-row">配件厂家价格：{{ priceItem.channelPartQuote }}</div>
									</div>
								</div>
							</template>
							<template v-else>
								<div class="flow-row">
									<span class="flow-label">操作时间</span>
									<span class="flow-value">{{ item.woOperateTime }}</span>
								</div>
								<div class="flow-row">
									<span class="flow-label">操作人</span>
									<span class="flow-value">{{ item.woOperator }}</span>
								</div>
								<div class="flow-row">
									<span class="flow-label">备注</span>
									<span class="flow-value">{{ item.woRemarks }}</span>
								</div>
							</template>
						</div>
					</div>
				</div>
				
				<div class="module">
					<div class="module-title">
						<div class="module-title-text">在线申请照片</div>
					</div>
				</div>
				<div class="module-cont">
					<div class="photo-section">
						<div class="photo-title">损坏部位</div>
						<ul v-if="policyInfo.applyImageDTOS && policyInfo.applyImageDTOS.length > 0" class="el-upload-list el-upload-list--picture-card">
							<li
								tabindex="0"
								class="el-upload-list__item is-ready"
								v-for="(img, index) in policyInfo.applyImageDTOS"
								:key="index"
							>
								<el-image
									:src="'https://applyimage.hollardchina.com.cn/'+img.imageUrl"
									alt=""
									class="el-upload-list__item-thumbnail"
									:preview-src-list="['https://applyimage.hollardchina.com.cn/'+img.imageUrl]"
								/>
							</li>
						</ul>
						<div v-else class="no-photo">暂无损坏部位照片</div>
					</div>
				</div>
			</template>
			


			<div class="form-ctrls">
				<el-button @click="goBack">返回</el-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "claimDetail",
	components: {},
	data() {
		return {
			woRepairStatusList: [
				{
					value: 'rep_apply',
					label: "服务已受理待收理赔资料",
				},
				{
					value: 'rep_prepare_verify',
					label: "资料待审核",
				},
				{
					value: 'rep_replenish_data',
					label: "需补充资料",
				},
				{
					value: 'rep_refuse',
					label: "拒绝理赔",
				},
				{
					value: 'rep_accept',
					label: "审核通过，接受理赔(待报价)",
				},
				{
					value: 'rep_cancle',
					label: "客户取消理赔",
				},
				{
					value: 'rep_confirm_quote',
					label: "确认报价",
				},
				{
					value: 'rep_again_quote',
					label: "重新报价",
				},
				{
					value: 'rep_replenish_pay',
					label: "待付款",
				},
				{
					value: 'rep_self_payed',
					label: "已收自付款",
				},
				{
					value: 'rep_prepare_repair',
					label: "待维修",
				},
				{
					value: 'rep_done',
					label: "已维修待邮寄",
				},
				{
					value: 'rep_examine_success',
					label: "维修审核成功",
				},
				{
					value: 'rep_send',
					label: "维修已发货",
				},
				{
					value: 'rep_refuse_send',
					label: "拒绝已回寄",
				},
				{
					value: 'rep_self_taken',
					label: "客户自取",
				},
				{
					value: 'order_break',
					label: "工单中止",
				},
				{
					value: 'rep_total_loss',
					label: "全损工单",
				},
				{
					value: 'return_order',
					label: "核赔退回",
				},
				{
					value: 'order_accept',
					label: "审核通过",
				},
				{
					value: 'order_change',
					label: "已修改",
				},
				{
					value: 'order_refuse',
					label: "审核驳回",
				},
				{
					value: 'return_tl_order',
					label: "全损核赔退回",
				},
			],
			claimStatusList: [
				{ value: 1, label: "换新" },
				{ value: 2, label: "维修" },
				{ value: 3, label: "投诉" },
			],
			type: this.$route.query.type,
			id: this.$route.query.id,
			policyInfo: {
				dCreateTime: "",
				vCustomerName: "",
				vContactPhone: "",
				vCertificateType: "",
				vCertificateNo: "",
				vChannelName: "",
				vProductName: "",
				dPolicyEffectiveTime: "",
				dPolicyEndTime: "",
				vImeiCode: "",
			},
		};
	},
	created() {
		this.getInfo();
	},
	methods: {
		goBack() {
			this.$router.go(-1)
		},
		getInfo() {
			if (!this.id) {
				return;
			}
			const vm = this;
			let postData = {
				id: this.id,
			};
			this.$http
				.post(`/workOrder/queryWorkOrderDetail`, postData)
				.then(function (response) {
                    console.log('res', response);
					if (response.status == "200" && response.data) {
						vm.policyInfo = response.data || {};
					} else {
						vm.$message.warning('暂无数据');
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		},
	},
	computed: {
		cardInfo() {
			return {
				icon: "el-icon-document",
				name: "理赔详情",
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.detail-cont {
	background: #fff;
	padding: 20px;
	min-height: 100%;
}
.detail-wrapper {
	max-width: 1200px;
	margin: 0 auto;
}

.module {
	border-bottom: 1px solid #eee;
	margin-bottom: 16px;
	.module-title {
		display: flex;
		justify-content: space-between;
		padding: 4px 10px;
		border-left: 4px solid #409eff;
		margin-bottom: 8px;
	}
}
.module-title-text {
	font-weight: 700;
	color: #333;
	font-size: 14px;
}
.module-cont {
	margin-bottom: 20px;
}

.info-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px 0;
}
.info-item {
	display: flex;
	align-items: flex-start;
	padding: 0 10px;
	.info-label {
		font-weight: 700;
		color: #333;
		width: 120px;
		text-align: right;
		flex-shrink: 0;
		margin-right: 12px;
	}
	.info-value {
		flex: 1;
		word-break: break-all;
	}
}

.flow-item {
	margin-bottom: 16px;
	padding-bottom: 16px;
	border-bottom: 1px dashed #eee;
	&:last-child {
		border-bottom: none;
		margin-bottom: 0;
		padding-bottom: 0;
	}
}
.flow-info {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 12px 0;
}
.flow-row {
	display: flex;
	align-items: flex-start;
	padding: 0 10px;
	.flow-label {
		font-weight: 700;
		color: #333;
		width: 100px;
		text-align: right;
		flex-shrink: 0;
		margin-right: 12px;
	}
	.flow-value {
		flex: 1;
		word-break: break-all;
	}
}
.status-row {
	grid-column: span 3;
	.status-text {
		margin-left: 30px;
		font-size: 16px;
		font-weight: 700;
		color: #409eff;
	}
}

.quote-section {
	grid-column: span 3;
	margin-left: 80px;
	padding-top: 12px;
}
.quote-label {
	font-weight: 700;
	color: #333;
	margin-bottom: 12px;
	font-size: 14px;
}
.quote-box {
	display: flex;	
	margin-bottom: 16px;
	padding: 12px;
	background: #fafafa;
	border-radius: 4px;
	&:last-child {
		margin-bottom: 0;
	}
}
.quote-row {
	margin-bottom: 8px;
	margin-right: 20px;
	&:last-child {
		margin-bottom: 0;
	}
}

.photo-section {
	margin-bottom: 20px;
	.photo-title {
		font-weight: 700;
		color: #333;
		margin-bottom: 12px;
		font-size: 14px;
	}
}
.no-photo {
	text-align: center;
	color: #999;
	padding: 20px 0;
}
</style>